export default __webpack_public_path__ + "static/media/login_smartphone_1.2fba81d2.png";